export const SIZE = {
  mobile: '320px',
  iphone: '427px',
  tablet: '767px',
  desktopS: '1024px',
  desktop: '1280px',
  bigDesktop: '1919px',
};

export const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '428px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1280px',
  laptopM: '1279px',
  desktop: '1920px',
};
